import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'reports',
    loadChildren: () => import('./features/reports/reports.module').then(m => m.ReportsModule),
  },
  {
    path: 'docs',
    loadChildren: () =>
      import('./features/documents/order-confirmation/order-confirmation.module').then(
        m => m.OrderConfirmationModule,
      ),
  },
  {
    path: 'error',
    component: NotFoundComponent,
  },
  {
    path: '',
    redirectTo: '/reports',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/error',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
